import { getEndpointURL, composedFetch } from './helpers'
import { errorIfInvalidResponse } from './errors'
import { getCurrentUserIdToken } from '@/services/auth'
import { UsageDocument } from '@/store/types/event'
import { timestampDateInRange } from '@/services/date'

const eventEndpointUrl = getEndpointURL('events/')

const getEventsByUserIdURL = (uuid: string): string => eventEndpointUrl + uuid

export const getUserEvents = async (
  userId: string,
  range: [Date, Date] | undefined,
): Promise<any> => {
  const response = await composedFetch(
    'GET',
    getEventsByUserIdURL(userId),
    await getCurrentUserIdToken(),
  )

  await errorIfInvalidResponse(response)
  const events = await response.json()
  const rows: Array<UsageDocument> = []

  for (const event of events.results) {
    const data = event
    if (range instanceof Array && timestampDateInRange(data.timestamp, range)) {
      // Date, Date tuple
      continue
    }
    rows.push({
      uuid: data.uuid,
      categoryName: data.category_name,
      resource: data.resource,
      userId,
      resourceId: data.resource_id,
      timestamp: data.timestamp,
    })
  }

  return rows
}
